module.exports = __webpack_public_path__ + "media/images/covers/PrepWorks_Student-Testimonial_Sachdev-Singh_Poster-5a7958d516d1b49291698f7781507a87.jpg";